import * as Elements from './CloseButton.elements';

const CloseButton = props => (
  <Elements.Button {...props}>
    <Elements.Close className='h-5 w-5 text-gray-500' />
  </Elements.Button>
);

export default CloseButton;
